/** Returns true when the given post belongs to the current user profile. */
export const isPostOwnedByUser = (
  post?: { userId?: string | number | null; username?: string | null; authorId?: string | number | null } | null,
  profile?: { id?: string | number | null; userId?: number | string | null; name?: string | null; userGuid?: string | null } | null,
): boolean => {
  if (!post || !profile) {
    return false;
  }

  const loggedInUserId = profile.userId ?? profile.id ?? profile.userGuid;
  const postAuthorId = post.userId ?? post.authorId;

  if (postAuthorId != null && postAuthorId !== '' && loggedInUserId != null && loggedInUserId !== '') {
    return String(postAuthorId) === String(loggedInUserId);
  }

  const postUsername = post.username?.trim().toLowerCase();
  const profileName = profile.name?.trim().toLowerCase();
  if (postUsername && profileName) {
    return postUsername === profileName;
  }

  return false;
};
